module.exports = __webpack_public_path__ + "static/media/_BID5495.45088227.png";